import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconSave } from "../../../../images/iconSave.svg";

import AccordionSummaryTitle from ".././AccordionSummaryTitle";
import { FieldTextarea } from "../../../../components/Fields";

import "../styles.css";

const handleProgressForm = (data) => {
  const fieldHide = "*";

  const fields = [data.condutaConclusaoEncaminhamentos];

  if (fields.every((campo) => campo !== "")) {
    return "full";
  } else if (fields.some((campo) => campo !== "" && campo !== fieldHide)) {
    return "partial";
  } else {
    return "empty";
  }
};

export default function Condutas({
  expanded,
  handleChangePanel,
  handleSubmit,
  data,
  setData,
}) {
  const progressForm = handleProgressForm(data);

  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded === "condutas"}
      onChange={handleChangePanel("condutas")}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className="AccordionSummaryContainer"
      >
        <AccordionSummaryTitle
          title="Condutas"
          icon={<IconSave style={{ width: "24px" }} />}
          progressForm={progressForm}
        />
      </AccordionSummary>
      <AccordionDetails>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <FieldTextarea
            label="Conduta, conclusões e encaminhamentos"
            value={data.condutaConclusaoEncaminhamentos ?? ""}
            setValue={(value) =>
              setData((prevState) => ({
                ...prevState,
                condutaConclusaoEncaminhamentos: value,
              }))
            }
          />

          <Stack
            direction="row"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 3,
            }}
          >
            <Button variant="outlined" className="buttonText cancel">
              Cancelar
            </Button>
            <Button
              className="buttonText submit"
              variant="contained"
              type="submit"
              name="condutaConclusaoEncaminhamentos"
            >
              Salvar
            </Button>
          </Stack>
        </form>
      </AccordionDetails>
    </Accordion>
  );
}
